webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_aboutus_IndexAboutus__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_aboutus_IndexAboutus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_aboutus_IndexAboutus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_applyproject_IndexApplyproject__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_applyproject_IndexApplyproject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_applyproject_IndexApplyproject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_contactus_IndexContactus__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_contactus_IndexContactus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_contactus_IndexContactus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_home_IndexHome__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_home_IndexHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_home_IndexHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_pagenotfound_IndexPagenotfound__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_pagenotfound_IndexPagenotfound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_pagenotfound_IndexPagenotfound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_portofolios_IndexPortofolios__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_portofolios_IndexPortofolios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_portofolios_IndexPortofolios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_portofolios_ShowPortofolio__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_portofolios_ShowPortofolio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_portofolios_ShowPortofolio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_services_IndexServices__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_services_IndexServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_services_IndexServices__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'IndexHome',
    component: __WEBPACK_IMPORTED_MODULE_5__views_home_IndexHome___default.a
  }, {
    path: '/about-us',
    name: 'IndexAboutus',
    component: __WEBPACK_IMPORTED_MODULE_2__views_aboutus_IndexAboutus___default.a
  }, {
    path: '/apply-project',
    name: 'IndexApplyproject',
    component: __WEBPACK_IMPORTED_MODULE_3__views_applyproject_IndexApplyproject___default.a
  }, {
    path: '/contact-us',
    name: 'IndexContactus',
    component: __WEBPACK_IMPORTED_MODULE_4__views_contactus_IndexContactus___default.a
  }, {
    path: '/portofolios',
    redirect: '/portofolios',
    name: 'Portofolios',
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '/',
      name: 'IndexPortofolios',
      component: __WEBPACK_IMPORTED_MODULE_7__views_portofolios_IndexPortofolios___default.a
    }, {
      path: 'detail/:id',
      name: 'ShowPortofolio',
      component: __WEBPACK_IMPORTED_MODULE_8__views_portofolios_ShowPortofolio___default.a
    }]
  }, {
    path: '/services',
    name: 'IndexServices',
    component: __WEBPACK_IMPORTED_MODULE_9__views_services_IndexServices___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_6__views_pagenotfound_IndexPagenotfound___default.a
  }]
}));

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appHeader__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appFooterintermezo__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appFooterintermezo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appFooterintermezo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appFooter__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_appFooter__);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    appHeader: __WEBPACK_IMPORTED_MODULE_0__components_appHeader___default.a,
    appFooterintermezo: __WEBPACK_IMPORTED_MODULE_1__components_appFooterintermezo___default.a,
    appFooter: __WEBPACK_IMPORTED_MODULE_2__components_appFooter___default.a
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({ name: 'appFooter' });

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({ name: 'appFooterintermezo' });

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({ name: 'appHeader' });

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexAboutus',
  data: function data() {
    return {
      msg: 'Index about'
    };
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vee_validate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexApplyproject',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexContactus',
  data: function data() {
    return {
      msg: 'Index contact us'
    };
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexHome',
  data: function data() {
    return {
      projects: [{
        id: 1,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 2,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 3,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 4,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 5,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 6,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 7,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 8,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }],
      technologies_desc: [{
        id: 1,
        img: 'static/images/gallery/internet/internet-1.png',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut, nihil accusantium.'
      }, {
        id: 2,
        img: 'static/images/gallery/internet/internet-1.png',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut, nihil accusantium.'
      }, {
        id: 3,
        img: 'static/images/gallery/internet/internet-1.png',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut, nihil accusantium.'
      }, {
        id: 4,
        img: 'static/images/gallery/internet/internet-1.png',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aut, nihil accusantium.'
      }]
    };
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Pagenotfound',
  data: function data() {
    return {
      msg: 'Maaf, halaman tidak ditemukan dalam sistem'
    };
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexPortofolios',
  data: function data() {
    return {
      projects: [{
        id: 1,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 2,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 3,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 4,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 5,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 6,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 7,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }, {
        id: 8,
        img: 'static/images/gallery/bg1.jpg',
        title: 'Judul portofolio',
        type: 'Type portofolio'
      }]
    };
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPortofolio',
  data: function data() {
    return {
      msg: 'show portofolio'
    };
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexServices',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(76),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(73),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(74),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a82b91ee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(68),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22e89e25",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(65),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fa49fae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(70),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-573e6de6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-580aa66a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(66),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1aca14ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(72),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7a236a5b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(45)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(67),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b4c91cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexContactus"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg))])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexPortofolios"
    }
  }, [_c('section', {
    staticClass: "sub--header diagonal-shadow mg-bottom-diagonal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPortofolio\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "list-portofolio"
    }, [_c('div', {
      staticClass: "list-portofolio__image"
    }, [_c('img', {
      attrs: {
        "src": project.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-description"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": 'portofolios/detail/3'
      }
    }, [_vm._v("\n                    " + _vm._s(project.title) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v("\n                    " + _vm._s(project.type) + "\n                  ")])], 1)])])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tlatest project\n\t\t\t\t\t\t\t")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexServices"
    }
  }, [_c('section', {
    staticClass: "sub--header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tServis Kami\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "nav-target",
    attrs: {
      "id": "navigation-type-service"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-list-nav"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#bussinessprocess"
    }
  }, [_vm._v("Bussines Proces")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#company-profile"
    }
  }, [_vm._v("Company Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#ecommerce"
    }
  }, [_vm._v("E-Commerce")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#sisteminformasi"
    }
  }, [_vm._v("Sistem Informasi")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#buildstartup"
    }
  }, [_vm._v("Build Start Up")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#webapplication"
    }
  }, [_vm._v("Web App")])]), _vm._v(" "), _c('li', {
    staticClass: "tech"
  }, [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#technologies"
    }
  }, [_vm._v("Technologies")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper service-page-wrapper bg-white",
    attrs: {
      "id": "bussinessprocess"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPROCESS BUSSINES/AGILE PROJECT MANAGEMENT\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe necessitatibus temporibus sint, soluta, repellat eum suscipit dolorum numquam sunt reiciendis perferendis dolores velit ad voluptas architecto accusamus, placeat eveniet ipsam?\n\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "service-wrapper__image-process"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/agile.png",
      "alt": ""
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "company-profile"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCompany Profile\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/company-profile.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-white",
    attrs: {
      "id": "ecommerce"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/ecommerce.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tE-Commerce\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "sisteminformasi"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tSistem Informasi\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet lorem")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/sisteminformasi.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-white",
    attrs: {
      "id": "buildstartup"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/startup.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tBuild Start Up\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "webapplication"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tWeb App\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/webapp.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper",
    attrs: {
      "id": "technologies"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tTechnologies Use\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet totam officia facilis inventore asperiores illo animi nisi iusto maiores similique, explicabo sint a. Minus, labore, hic exercitationem at ab ea!\n\t\t\t\t\t\t\t")])])])])])])
}]}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexApplyproject"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.errors.first('email')) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tformulir apply project\n\t\t\t\t\t\t\t")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Nama Lengkap")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Website URL")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Dapat dari mana info kami")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Pilih salah satu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Internet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Teman")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Telepon")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Plan to Start")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Pesan anda")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Masukan Dokumen anda")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-lg btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tKirim\n\t\t\t\t\t\t\t\t\t\t")])])
}]}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Footerintermezo"
    }
  }, [_c('section', {
    staticClass: "intermezo-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n                LIHAT SEMUA PORTOFOLIO\n              ")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "box-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                  Ayo buat aplikasimu sekarang juga\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n                  Dengan kami Brand anda semuanya menjadi lebih profesional\n                ")])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexHome"
    }
  }, [_c('section', {
    staticClass: "banner-top"
  }, [_c('div', {
    staticClass: "banner-top__image-background"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "http://www.primewalls.com/images/magnetic-banner.jpg",
      "alt": "Corporate IT Profesional"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-description"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Consultant IT Profesional\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus temporibus culpa alias architecto, blanditiis ex neque consequuntur quo, non inventore ab expedita tempora? Inventore error nulla, fuga. Voluptates, laboriosam, laborum!\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-default",
    attrs: {
      "to": 'about-us'
    }
  }, [_vm._v("\n              Abut Us\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_vm._v("\n              Portofolio\n            ")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "intermezo-banner-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n              LIHAT SEMUA PORTOFOLIO\n            ")])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "point-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.technologies_desc), function(tech) {
    return _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "point-wrapper__box-point"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": tech.img,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_c('p', [_vm._v(_vm._s(tech.description))])])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-block btn-lg btn-warning",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n                LIHAT SEMUA PORTOFOLIO\n              ")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "list-portofolio"
    }, [_c('div', {
      staticClass: "list-portofolio__image"
    }, [_c('img', {
      attrs: {
        "src": project.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-description"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": 'portofolios/detail/3'
      }
    }, [_vm._v("\n                  " + _vm._s(project.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v("\n                  " + _vm._s(project.type) + "\n                ")])], 1)])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n              LIHAT SEMUA PORTOFOLIO\n            ")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Ayo Buat aplikasimu sekarang juga!\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper service-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Our Services\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "service-wrapper__list-service"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/company-profile.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Company Profile\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/online-shop.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  E-Commerce\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/sistem-informasi.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Sistem Informasi\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/world-map.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Web App\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/startup.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Build Start Up\n                ")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "point-wrapper__box-title-top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                  Kebutuhan Teknologi\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat numquam eum incidunt, eos a, magnam maxime aliquam. A nobis sunt vitae.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-wrapper__box-counting"
  }, [_c('div', {
    staticClass: "box-head"
  }, [_c('div', {
    staticClass: "count-big"
  }, [_vm._v("\n                    50\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "count-desc"
  }, [_vm._v("\n                    total client\n                  ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_c('span', [_vm._v("30")]), _vm._v(" company")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("10")]), _vm._v(" online store")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("05")]), _vm._v(" goverment")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("05")]), _vm._v(" personal")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              latest project\n            ")])])])])
}]}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Pagenotfound"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg))])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "ShowPortofolio"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg) + " - " + _vm._s(this.$route.params.id))])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "header-corporate"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": '/'
    }
  }, [_c('img', {
    attrs: {
      "src": "https://daks2k3a4ib2z.cloudfront.net/578266d29776c827488589dc/578abbe68ad454da63985cb2_trello-logo-white.png",
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-menu-top"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      },
      "exact": ""
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/about-us'
      },
      "exact": ""
    }
  }, [_vm._v("About Us")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/services'
      },
      "exact": ""
    }
  }, [_vm._v("Services")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/portofolios'
      },
      "exact": ""
    }
  }, [_vm._v("Portofolio")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact-us'
      },
      "exact": ""
    }
  }, [_vm._v("Contact Us")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-menu-top",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexAbouts"
    }
  }, [_c('section', {
    staticClass: "sub--header diagonal-shadow mg-bottom-diagonal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAbout us\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper bg-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-information"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tabout us\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo dolore ipsum, autem ipsa est doloribus iure necessitatibus impedit explicabo optio nihil assumenda velit dignissimos vel, sapiente aperiam voluptatibus accusantium eius.\n\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCOMPANY PROFILE DOWNLOAD\n\t\t\t\t\t\t\t")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper about-us"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title txt-white"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPerkenalkan Team Kami\n\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/lutfi.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLutfi Satria Ramdhani\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSistem Analis\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/febry.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFebryan Setiawan\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSr.Backend Developer\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/fathan.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFathan Rohman\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSr.Frontend Developer - UI/UX Designer\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/chris.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tChristian Tobing\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tBussines Development\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/farry.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFarry Abimael Argobie\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSr.Fullstack Developer\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/jos.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tRamdhani Haris\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tFrontend Developer\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team"
  }, [_c('div', {
    staticClass: "box-list-team__image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/team/audi.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAudi Irawan\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "box-list-team__position"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tMobile Developer\n\t\t\t\t\t\t\t")])])])])])])
}]}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('appHeader'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('appFooterintermezo'), _vm._v(" "), _c('appFooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer-wrapper box-desc-social"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "list-info"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                About Company\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio minus incidunt, quos libero a illo amet deleniti tempore, modi obcaecati autem vitae, labore doloribus reiciendis veniam quod minima quibusdam reprehenderit!\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "list-info"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                Contact Us\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                  Address: Jl TB Simatupang No.30 Gd Talavera Suite 6 BGH\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  Phone: 085692268882\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  Email: sales@company.com\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box-desc-social"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Follow Us\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "http://facebook.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": "http://twitter.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "href": "http://google.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "http://linkedin.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-corpyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("2017 © Corpyright - PT. Consultant IT Profesional")])])])])])])
}]}

/***/ })
],[30]);


// WEBPACK FOOTER //
// static/js/app.d008336c429e642d0bbf.js